(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-main-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-product-main-countdown]:not([data-countdown-initialized])';

    const parseBeijingTime = (value) => {
      const parts = value.trim().match(/^(\d{4})[/-](\d{1,2})[/-](\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);

      if (parts) {
        return new Date(Date.UTC(
          Number(parts[1]),
          Number(parts[2]) - 1,
          Number(parts[3]),
          Number(parts[4] || 0) - 8,
          Number(parts[5] || 0),
          Number(parts[6] || 0)
        ));
      }

      return new Date(value);
    };

    const initializeCountdown = (countdown) => {
      countdown.dataset.countdownInitialized = 'true';
      const target = parseBeijingTime(countdown.dataset.beijingEndTime);

      if (Number.isNaN(target.getTime())) {
        countdown.hidden = true;
        return;
      }

      const time = countdown.querySelector('.product-countdown__time');
      const days = countdown.querySelector('[data-countdown-days]');
      const hours = countdown.querySelector('[data-countdown-hours]');
      const minutes = countdown.querySelector('[data-countdown-minutes]');
      const seconds = countdown.querySelector('[data-countdown-seconds]');
      let intervalId;

      const update = () => {
        const remaining = target.getTime() - Date.now();

        if (remaining <= 0) {
          countdown.hidden = true;
          window.clearInterval(intervalId);
          return;
        }

        days.textContent = String(Math.floor(remaining / 86400000));
        hours.textContent = String(Math.floor((remaining % 86400000) / 3600000)).padStart(2, '0');
        minutes.textContent = String(Math.floor((remaining % 3600000) / 60000)).padStart(2, '0');
        seconds.textContent = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
        time.classList.add('is-ready');
      };

      update();
      intervalId = window.setInterval(update, 1000);
    };

    const initializeAllCountdowns = (root = document) => {
      root.querySelectorAll(selector).forEach(initializeCountdown);
    };

    initializeAllCountdowns();
    document.addEventListener('shopify:section:load', (event) => initializeAllCountdowns(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
